export const LOCAL_STORAGE_KEYS = {
  SELECTED_PRIMARY_ORG: 'selectedPrimaryOrg',
  TRANSLOCO_LANG: 'translocoLang'
} as const;
